import { useTranslation } from "react-i18next";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import Tooltip from "@mui/material/Tooltip";

export function ConfirmButton(props: IconButtonProps) {
  const { t } = useTranslation();

  return (
    <Tooltip title={<div>{t("common.save")}</div>}>
      <IconButton color="primary" {...props} size="large">
        <CheckIcon color="primary" />
      </IconButton>
    </Tooltip>
  );
}
